import { fetcher } from '../utils'
import { ComponentInfoVO } from '@repo/types'

export default async (): Promise<ComponentInfoVO> => await fetcher(`/api/componentInfo`, 'POST', {})
